export default [
  // CLient端 交易账号相关接口
  // 申请交易账号
  {
    name: "CreateTradingAccount",
    url: "/account/create",
    method: "POST",
    mock: false,
  },
  // 删除交易账号
  {
    name: "DeleteTradingAccount",
    url: "/account/delete",
    method: "POST",
    mock: false,
  },
  // 查询交易账号
  {
    name: "GetTradingAccount",
    url: "/account/get",
    method: "GET",
    mock: false,
  },
  // 查询可用交易账号类型列表
  {
    name: "GetAvailableTradingAccountTypeOptions",
    url: "/account/get-type-options",
    method: "GET",
    mock: false,
  },
  // 查询交易账号列表
  {
    name: "ListTradingAccount",
    url: "/account/list",
    method: "GET",
    mock: false,
  },
  // 更新交易账号
  {
    name: "UpdateTradingAccount",
    url: "/account/update",
    method: "POST",
    mock: false,
  },
  // 更新交易账号杠杆
  {
    name: "UpdateTradingAccountLeverage",
    url: "/account/update-leverage",
    method: "POST",
    mock: false,
  },
  // 更新交易账号密码
  {
    name: "UpdateTradingAccountPassword",
    url: "/account/update-password",
    method: "POST",
    mock: false,
  },
  // 查询交易账户可用杠杆
  {
    name: "GetTradingAccountLeverageOptions",
    url: "/account/get-leverage-options",
    method: "GET",
    mock: false,
  },
  // 查询交易账号杠杆更新状态
  {
    name: "GetTradingAccountLeverageUpdateStatus",
    url: "/account/get-leverage-update-status",
    method: "GET",
    mock: false,
  },
  //Broker端 交易账号相关接口

  // 查询交易账号
  {
    name: "GetAccount",
    url: "/account/get",
    method: "GET",
    mock: false,
  },

  // 查询是否允许开通模拟账户

  {
    name: "GetDemoTradingAccountAvailability",
    url: "/account/get-demo-availability",
    method: "GET",
    mock: false,
  },
  // 检查当前用户是否有待审核的出金订单
  {
    name: "CheckPendingWithdrawal",
    url: "/withdrawal/check-pending",
    method: "GET",
    mock: false,
  },
  // 获取可用交易平台选项列表
  {
    name: "ListTradingPlatform",
    url: "/account/list-platform",
    method: "GET",
    mock: false,
  },
  // 查询交易账号选项列表
  {
    name: "GetAccountListOptions",
    url: "/account/list-options",
    method: "GET",
    mock: false,
  },
];
